import React from "react";
import { IColuna } from "../../../types/IColuna";
import { AcoesHeadEstoque } from "./AcoesHeadEstoque";
import { HeadersEstoque } from "./HeaderEstoque";

export type TableHeadPesquisarClienteProps = {
  onAlterarFonte: (tamanho: number) => void;
  colunas: IColuna[];
  onToggleColunaSelecionada: (nomeColuna: string, selecionada: boolean) => void;
  onToggleSelecionarTodasColunas: (selecionar: boolean) => void;
  tamanhoFontePadrao: number;
  permiteEngrenagemGrid: boolean
};

export const TableHeadEstoque = (
  props: TableHeadPesquisarClienteProps
) => {
  return (
    <>
      <AcoesHeadEstoque
        permiteEngrenagemGrid={props.permiteEngrenagemGrid}
        onToggleColunaSelecionada={props.onToggleColunaSelecionada}
        onAlterarFonte={props.onAlterarFonte}
        tamanhoFonte={props.tamanhoFontePadrao}
        colunas={props.colunas}
        onToggleSelecionarTodasColunas={props.onToggleSelecionarTodasColunas}
      />
      <HeadersEstoque colunas={props.colunas} />
    </>
  );
};
